import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { useSnackbar } from "notistack";
import { Grid, Paper, Tab, Tabs, TextField, Typography, Checkbox, Box, Tooltip } from '@material-ui/core'
import { Info } from '@material-ui/icons';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SecondaryThrustModal from "./SecondaryThrustModal";
import ConfigData from '../../master/components/ConfigData'
import { globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { PageLoader } from "../../../shared_elements";
import ThrustCategory from "../../thrustCategory/pages";
import { titanAviInstance } from "../../../../shared/components";

const EngineFamilyView = () => {
    const [tabValue, setTabValue] = useState(0);
    const [engineFamilyViewInfo, setEngineFamilyViewInfo] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [enableThrust, setEnableThrust] = useState({ modal: false });
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        getEngineFamilyView();
    }, [])
    const FrontendUrl = window.location.pathname;
    const path = FrontendUrl.split('/');
    const id = path[path.length - 1];
    const getEngineFamilyView = (query) => {
        setLoading(true)
        globalGetService(`config-data/engine-families/${id}/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setEngineFamilyViewInfo(response?.data?.data)
                    setEnableThrust({ ...enableThrust, have_secondary_llp_thrust: response?.data?.data?.have_secondary_llp_thrust })
                }
                setLoading(false)
            })
    }
    const enableSecondaryThrust = (status) => {
        setLoading(true)
        globalPutService(`config-data/engine-families/${id}/secondary-llp-thrust/`, { have_secondary_llp_thrust: status })
            .then(response => {
                setLoading(false)
                if (checkApiStatus(response)) {
                    toggleModal()
                    setEngineFamilyViewInfo({ ...engineFamilyViewInfo, have_secondary_llp_thrust: status })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }
                setLoading(false)
            })
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const toggleModal = () => { setEnableThrust({ ...enableThrust, modal: false }) }
    return (
        <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content">
                    <div style={{ display: "flex", alignItems: 'center', marginLeft: "8px" }}>
                        <Link to="/config-data/engineFamily/" fontSize="small" classname="back-icon" style={{ color: "#3f51b5" }}><ArrowBackIcon style={{ color: "#3f51b5", verticalAlign: 'top' }} /></Link>
                        <Typography variant="h7" >{engineFamilyViewInfo?.name}</Typography>
                    </div>
                    <div className='console-management-modal' style={{ padding: "0px 10px" }}>
                        <Grid container spacing={1}>
                            <Grid item md={12} style={{ display: "flex", alignItems: 'center', justifyContent: titanAviInstance ? "center" : "normal" }}>
                                <Grid item md={6}>
                                    <TextField
                                        name='manufacturer'
                                        label='Manufacturer'
                                        disabled
                                        value={engineFamilyViewInfo?.manufacturer?.name || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                    />
                                </Grid>
                                {titanAviInstance ? <Grid item md={6} style={{ display: "flex", alignItems: 'center', marginTop: "14px", marginLeft: "14px" }}>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        sx={{
                                            cursor: "default",
                                            "& .MuiCheckbox-root": {
                                                padding: "9px"
                                            }
                                        }}
                                    >
                                        <Checkbox
                                            size="small"
                                            color="primary"
                                            checked={Boolean(engineFamilyViewInfo?.have_secondary_llp_thrust)}
                                            onChange={(e) => {
                                                setEnableThrust({
                                                    modal: true,
                                                    have_secondary_llp_thrust: e.target.checked
                                                });
                                            }}
                                        />
                                        <Box sx={{ display: "flex", alignItems: "center", fontSize: "13px", lineHeight: 1.43, color: "text.primary", userSelect: "none" }}>
                                            <span> {engineFamilyViewInfo?.have_secondary_llp_thrust ? "Disable" : "Enable"}{" "} Thrust Categories For Secondary LLP </span>
                                            <Tooltip  title={ engineFamilyViewInfo?.have_secondary_llp_thrust ? "This will disable the thrust categories for Secondary LLP" : "Secondary LLPs will follow the same thrust categories as the Primary LLP" } arrow ><span> <Info fontSize="small" sx={{ ml: 0.5, transform: "scale(1.1)", verticalAlign: "middle" }} /> </span></Tooltip>
                                        </Box>
                                    </Box>
                                </Grid> : null}
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled
                                    value={engineFamilyViewInfo?.remarks || ''}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div square style={{ padding: '4px 10px', marginTop: "5px" }}>
                        <Paper elevation={0} className="console-paper">
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab label="Thrust Categories" />
                            </Tabs>
                        </Paper>
                        {tabValue === 0 && <ThrustCategory id={id} />}
                    </div>
                </div>
            </Paper>
            {enableThrust?.modal ? <SecondaryThrustModal isLoading={isLoading} enableSecondaryThrust={enableSecondaryThrust} enableThrust={enableThrust?.have_secondary_llp_thrust} toggleModal={toggleModal} /> : null}
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}

export default EngineFamilyView